module.exports = __webpack_public_path__ + "img/order-delivered.a9f1badf.png";